<script lang="ts">
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
</script>

<div class="empty-card-content">
    <IconedContent icon="info" orientation="vertical" align="center" justify="center">
        Tato kartička se připravuje
    </IconedContent>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .empty-card-content {
        width: 100%;
        height: 360px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @themed-text-muted;
    }
</style>